import { Flex } from 'antd';
import { Analytics as AnalyticsModule } from '@modules/analytics';
import styles from './analytics.module.scss';

export const Analytics = () => (
  <Flex className={styles.root} align="center" justify="center">
    <AnalyticsModule />
  </Flex>
);
